import * as React from 'react';
import {useEffect, useState} from "react";
import {
    APP_ACTION_ITEMS, APP_LOGIN_PATH,
    AUTH_USER_EMAIL_KEY
} from "../../types";
import {useHistory} from "react-router-dom";
import {logout, signInCode} from "../../Auth";

const LoginCode: React.FunctionComponent = () => {

    const [username, setUsername] = useState("");
    const [code, setCode] = useState("");
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState("");
    const [doRedirectToLogin, setDoRedirectToLogin] = useState(false);
    const history = useHistory();

    const [doActionItemRedirect, setDoActionItemRedirect] = useState(false);


    useEffect(() => {
        const username = localStorage.getItem(AUTH_USER_EMAIL_KEY);
        setUsername(username || "");
    }, []);

    useEffect(() => {
        if (doActionItemRedirect) {
            history.push({
                pathname: APP_ACTION_ITEMS
            });
        }
    }, [doActionItemRedirect, history]);


    const onSubmit = (event: React.FormEvent) => {
        event.preventDefault();
        setLoading(true);
        signInCode(username, code)
            .then((o) => {
                setDoActionItemRedirect(true);
            }).catch((e) => {
            console.log(e);
        }).finally(() => setLoading(false));
    };

    const doCancel = () => {
        logout();
        setDoRedirectToLogin(true);
    }

    useEffect(() => {
        if (doRedirectToLogin) {
            history.push({
                pathname: APP_LOGIN_PATH
            });
        }
    }, [doRedirectToLogin, history]);

    return (
        <>
            <div className={"container mt-3"}>
                <div className={"row justify-content-md-center mb-3"}>
                    <img alt={"logo"} src={"/assets/dist/img/promises12_logo.jpg"}/>
                </div>
                <div className={"row justify-content-md-center mb-3"}>
                    <h5>Enter the login code sent to your email at {username}</h5>
                </div>
                <form onSubmit={onSubmit}>
                    <div className={"row justify-content-md-center"}>
                        <div className={"col-md-3 mb-3"}>
                            <input disabled={true} type="text" className="form-control" id="username"
                                   placeholder={"username"} value={username} required={true}
                                   onChange={e => setUsername(e.target.value)}/>
                        </div>
                    </div>
                    <div className={"row justify-content-md-center"}>
                        <div className={"col-md-3 mb-3"}>
                            <input type="text" className="form-control" id="code"
                                   placeholder={"code"} required={true} value={code}
                                   onChange={e => setCode(e.target.value)}/>
                        </div>
                    </div>

                    <div className={"row justify-content-md-center"}>
                        <div className={"col-md-3 mb-3"}>
                            <button disabled={loading} type="submit" className="btn btn-primary btn-block">Submit
                            </button>
                        </div>
                    </div>

                    <div className={"row justify-content-md-center"}>
                        <div className={"col-md-3 mb-3"}>
                            <button disabled={loading} onClick={() => {
                                doCancel();
                            }} type="button" className="btn btn-danger btn-block">Cancel
                            </button>
                        </div>
                    </div>

                    <div className={"row justify-content-md-center"}>
                        <div className={"col-md-3 mb-3"}>
                            <div hidden={(!message)} className="alert alert-danger" role="alert">
                                {message}
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </>
    );
}

export default LoginCode;